import { QuotePayerAllocationsService } from "@common/client"
import { makeAxiosMutation, makeQuery } from "../utils"

export const payerAllocationsBaseKey = ["quote-payer-allocations"] as const

export const payerAllocationsKey = (quoteId: string) =>
  [...payerAllocationsBaseKey, quoteId] as const

export const payerAllocationsQuery = makeQuery({
  serviceCall: QuotePayerAllocationsService.listPayerAllocations,
  queryKey: (params) => payerAllocationsKey(params.quote_id),
})

export const useCreatePayerAllocationMutation = makeAxiosMutation({
  serviceCall: QuotePayerAllocationsService.create,
  invalidates: (params) => [payerAllocationsKey(params.quote_id)],
})

export const useUpdatePayerAllocationMutation = makeAxiosMutation({
  serviceCall: QuotePayerAllocationsService.update,
  invalidates: (params) => [payerAllocationsKey(params.quote_id)],
})

export const useDeletePayerAllocationMutation = makeAxiosMutation({
  serviceCall: QuotePayerAllocationsService.delete,
  invalidates: (params) => [payerAllocationsKey(params.quote_id)],
})
